module.exports = __webpack_public_path__ + "media/src/assets/Roboto/Roboto-Light-fc84e998bc29b297ea20321e4c90b6ed.ttf";